import { deleteJSON } from './api'

const returnKey = 'authem:account-links-reauthentication'
const returnPath = '/account/connectors'
const lifetime = 10 * 60 * 1000

export async function reauthenticateForAccountLinks(): Promise<void> {
  await deleteJSON('/api/v1/session')
  // Only a fixed local destination is persisted, never credentials or a URL
  // supplied by a caller. localStorage carries the return across email tabs.
  try {
    const started = Date.now()
    localStorage.setItem(returnKey, JSON.stringify({ started, expires: started + lifetime }))
  } catch { /* Sign-in still works when browser storage is unavailable. */ }
}

export function takeReauthenticationReturn(authTime: string): string | null {
  try {
    const value = localStorage.getItem(returnKey)
    if (!value) return null
    const marker = JSON.parse(value) as { started: number; expires: number }
    const now = Date.now()
    if (!Number.isFinite(marker.started) || !Number.isFinite(marker.expires)
      || marker.expires <= now || marker.expires > now + lifetime) {
      localStorage.removeItem(returnKey)
      return null
    }
    const authenticated = Date.parse(authTime)
    if (!Number.isFinite(authenticated) || authenticated < marker.started - 1000) return null
    localStorage.removeItem(returnKey)
    return returnPath
  } catch {
    try { localStorage.removeItem(returnKey) } catch { /* Storage may be disabled. */ }
    return null
  }
}
